<template>
  <div class="font-apercu-medium" ref="enquiryContainer">
    <!-- 遮罩层：捕获阶段阻止所有滚动事件 -->
    <div
      class="enquiry-drawer-overlay"
      :class="{ 'visible': isOpen }"
      @click="closeEnquiryDrawer"
      @wheel.prevent.capture
      @touchmove.prevent.capture
      @mousewheel.prevent.capture
      @DOMMouseScroll.prevent.capture
      style="touch-action: none;"
    ></div>

    <!-- 抽屉主体：内部滚动正常，阻止事件冒泡 -->
    <div
      class="enquiry-drawer"
      :class="{ 'open': isOpen }"
      @wheel.stop
      @touchmove.stop
    >
      <div class="drawer-content">
        <!-- 左侧列表 -->
        <div class="drawer-list-column">
          <div class="drawer-header" :style="{ borderBottom: enquiryList.length === 0 ? '0 solid #000' : '1rem solid #000' }">
            <h2 class="font-apercu-medium">Enquiry List ({{ enquiryList.length }})</h2>
          </div>

          <div v-if="enquiryList.length === 0">
            <div class="form-intro">
              <p>Bit empty in here, isn't it?</p>
              <p>Go find something nice.</p>
            </div>
            <div style="margin-top: 132rem;">
              <button class="send-enquiry-btn font-apercu-medium" @click="goHome">[Browse]</button>
            </div>
          </div>

          <div v-if="loading" class="loading-indicator">Loading...</div>

          <transition-group
            v-else
            name="list"
            tag="div"
            class="enquiry-list-scroll-area"
            @wheel.stop
            @touchmove.stop
          >
            <div
              class="enquiry-item"
              v-for="item in enquiryList"
              :key="item.CartID || item.localId"
              :class="{ 'empty-customization': !item.isCustomise, 'expanded': item.isCustomise }"
            >
              <div class="item-image">
                <img :src="item.image" alt="Product">
              </div>
              <div class="item-details" :class="{ 'empty-customization-item-details': !item.isCustomise }">
                <div class="item-top">
                  <div class="item-top-left">
                    <span class="item-category">{{ item.category }}</span>
                    <span class="item-name">{{ item.name }}</span>
                  </div>
                  <button class="remove-btn" @click="removeEnquiryListItem(item)">Remove</button>
                </div>

                <div class="item-options">
                  <label class="drawer-customise-checkbox">
                    <input type="checkbox" v-model="item.isCustomise" @change="updateCustomizeStatus(item)" />
                    <span class="checkmark"></span>
                    <span class="label-text" style="font-size: 13rem;">Customise</span>
                  </label>
                  <transition name="expand">
                    <div v-if="item.isCustomise" class="customization-input-container">
                      <textarea
                        v-model="item.customizationText"
                        placeholder="Tell us how you'd make it yours."
                        class="customization-input"
                        :class="{ 'has-text': item.customizationText && item.customizationText.length > 0 }"
                        rows="2"
                        @focus="handleInputFocus(item)"
                        @blur="handleInputBlur(item)"
                        @input="autoResize($event)"
                      ></textarea>
                      <div v-show="item.showSaveBtn" class="save-btn-container" @mousedown.prevent="saveCustomization(item)">
                        <span class="save-btn">[Save]</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </transition-group>
        </div>

        <!-- 右侧表单 -->
        <div class="drawer-form-column" style="padding-right: 40rem;padding-top: 23rem;">
          <div class="drawer-header-icons">
            <div class="header-icon-group">
              <button class="icon-btn"><img src="@/assets/icon/logo_black.png" alt="User" class="icon-img" @click="openMessagePopup" /></button>
              <button class="icon-btn">
                <div class="bag-icon-wrapper">
                  <img :src="enquiryIcon" alt="Bag" class="icon-img" style="display:flex; align-items: center;justify-content: center;" />
                </div>
              </button>
              <button class="icon-btn">
                <img src="@/assets/icon/search_black.png" alt="search" class="icon-img" @click="toggleSearch" />
              </button>
            </div>
          </div>
          <div class="form-intro">
            <p v-if="!loggedInUser">Fill in the form below,</p>
            <p v-if="!loggedInUser">Mr denHolm</p>
            <p v-if="!loggedInUser">will be with you shortly.</p>
            <div v-if="loggedInUser">
              <p class="font-apercu-medium">Fill in the form below,</p>
              <p class="font-apercu-medium">Mr denHolm</p>
              <p class="font-apercu-medium">will be with you shortly.</p>
            </div>
          </div>
          <form class="enquiry-form" @submit.prevent="sendEnquiryForm">
            <div class="form-group">
              <input type="text" placeholder="Name" class="drawer-input" v-model="formData.name" required />
            </div>
            <div class="form-group">
              <input type="email" placeholder="Email" class="drawer-input" v-model="formData.email" required />
            </div>
            <div class="form-group">
              <input type="text" placeholder="Phone (Optional)" class="drawer-input" v-model="formData.phone" />
            </div>
            <div class="form-group">
              <textarea placeholder="Additional Notes (Optional)" class="drawer-input textarea" v-model="formData.notes"></textarea>
            </div>
            <button type="submit" class="send-enquiry-btn font-apercu-medium" :disabled="submitting">
              {{ submitting ? 'Submitting...' : '[Send Enquiry]' }}
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- 删除确认弹窗 -->
    <transition name="popup-scale">
      <div v-if="showRemovePopup" class="remove-popup-overlay">
        <div class="remove-popup">
          <h3>Are you sure you want to remove<br>{{ itemToRemove ? itemToRemove.name : 'this item' }}?</h3>
          <p>This will also delete your saved messages.</p>
          <div class="remove-actions">
            <button class="cancel-btn" style="font-family: 'Apercu-Medium', sans-serif;" @click="cancelRemove">Nope I slipped.</button>
            <button class="confirm-btn" style="font-family: 'Apercu-Medium', sans-serif;" @click="confirmRemove">Yes please.</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- 提交成功弹窗 -->
    <transition name="enquiry-sent-anim">
      <div v-if="showEnquirySentPopup" class="enquiry-sent-popup-overlay" @click="closeEnquirySentPopup">
        <div class="enquiry-sent-popup">
          <h3>Enquiry Sent!</h3>
          <p class="product-count">{{ enquiryList.length }} Products</p>
          <p class="back-text">Keep your phone on,</p>
          <p class="back-text">we will be in touch shortly.</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { showMessage } from '@/config/message'
import { getUser } from '@/config/auth'
import { getCartItems, removeFromCart, updateCartItem, submitEnquiry } from '@/api/Enquiry'

import productBlackIcon from '@/assets/icon/product_black.png'
import icon1Black from '@/assets/cart/1-black.png'
import icon2Black from '@/assets/cart/2-black.png'
import icon3Black from '@/assets/cart/3-black.png'
import icon4Black from '@/assets/cart/4-black.png'
import icon5Black from '@/assets/cart/5-black.png'
import icon6Black from '@/assets/cart/6-black.png'
import icon7Black from '@/assets/cart/7-black.png'
import icon8Black from '@/assets/cart/8-black.png'
import icon9Black from '@/assets/cart/9-black.png'
import icon9BlackPlus from '@/assets/cart/9-black+.png'

const LOCAL_CART_KEY = 'pending_enquiry_items'

export default {
  name: 'Enquiry',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      enquiryList: [],
      loggedInUser: null,
      formData: { name: '', email: '', phone: '', notes: '' },
      showRemovePopup: false,
      itemToRemove: null,
      showEnquirySentPopup: false,
      submitting: false,
      iconMap: {
        'product-black': productBlackIcon,
        '1-black': icon1Black,
        '2-black': icon2Black,
        '3-black': icon3Black,
        '4-black': icon4Black,
        '5-black': icon5Black,
        '6-black': icon6Black,
        '7-black': icon7Black,
        '8-black': icon8Black,
        '9-black': icon9Black,
        '9+-black': icon9BlackPlus,
      }
    }
  },
  computed: {
    enquiryIcon() {
      const count = this.enquiryList.length
      let key = count === 0 ? 'product' : (count <= 9 ? String(count) : '9+')
      return this.iconMap[`${key}-black`] || this.iconMap['product-black']
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.loadCartItems()
        this.lockScroll()
      } else {
        this.unlockScroll()
      }
    }
  },
  mounted() {
    this.loadUser()
    this.loadCartItems()
    this.$root.$on('login-success', this.syncLocalCartToServer)
    this.$root.$on('cart-changed', this.loadCartItems)
  },
  beforeDestroy() {
    this.$root.$off('login-success', this.syncLocalCartToServer)
    this.$root.$off('cart-changed', this.loadCartItems)
    this.unlockScroll()
  },
  methods: {
    lockScroll() {
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = `-${window.scrollY}px`
    },
    unlockScroll() {
      const scrollY = parseInt(document.body.style.top || '0') * -1
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''
      if (scrollY > 0) {
        window.scrollTo(0, scrollY)
      }
    },
    goHome() {
      this.$router.push('/')
      this.$emit('close')
    },
    emitCartCount() {
      this.$root.$emit('update-cart-count', this.enquiryList.length)
    },
    loadUser() {
      const user = getUser()
      if (user) {
        this.loggedInUser = user
        this.formData.name = `${user.FirstName || ''} ${user.LastName || ''}`.trim() || user.Email
        this.formData.email = user.Email || ''
        this.formData.phone = user.Phone || ''
      } else {
        this.loggedInUser = null
        this.formData = { name: '', email: '', phone: '', notes: '' }
      }
    },
    getLocalCart() {
      const raw = localStorage.getItem(LOCAL_CART_KEY)
      return raw ? JSON.parse(raw) : []
    },
    saveLocalCart(items) {
      localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items))
    },
    async loadCartItems() {
      if (this.loggedInUser) {
        this.loading = true
        try {
          const items = await getCartItems(this.loggedInUser.UserID)
          this.enquiryList = items.map(item => ({
            CartID: item.CartID,
            ProductID: item.ProductID,
            image: item.ImageURL,
            category: item.CategoryName,
            name: item.ProductName,
            isCustomise: item.IsCustomized || false,
            customizationText: item.CustomisationText || '',
            showSaveBtn: false
          }))
        } catch (error) {
          console.error('Failed to load cart items:', error)
          showMessage('Failed to load enquiry list', 'error')
        } finally {
          this.loading = false
          this.emitCartCount()
        }
      } else {
        const localItems = this.getLocalCart()
        this.enquiryList = localItems.map(item => ({
          localId: item.localId || Date.now() + Math.random(),
          ProductID: item.ProductID,
          image: item.image,
          category: item.category,
          name: item.name,
          isCustomise: !!item.customizationText,
          customizationText: item.customizationText || '',
          showSaveBtn: false
        }))
        this.emitCartCount()
      }
    },
    async removeEnquiryListItem(item) {
      this.itemToRemove = item
      this.showRemovePopup = true
    },
    cancelRemove() {
      this.showRemovePopup = false
      this.itemToRemove = null
    },
    async confirmRemove() {
      if (!this.itemToRemove) return
      if (this.loggedInUser) {
        try {
          await removeFromCart(this.itemToRemove.CartID, this.loggedInUser.UserID)
          this.enquiryList = this.enquiryList.filter(i => i.CartID !== this.itemToRemove.CartID)
          // showMessage('Item removed', 'success')
          this.emitCartCount()
        } catch (error) {
          console.error('Remove failed:', error)
          showMessage('Failed to remove item', 'error')
        }
      } else {
        let localItems = this.getLocalCart()
        localItems = localItems.filter(i => i.localId !== this.itemToRemove.localId)
        this.saveLocalCart(localItems)
        this.enquiryList = this.enquiryList.filter(i => i.localId !== this.itemToRemove.localId)
        // showMessage('Item removed', 'success')
        this.emitCartCount()
      }
      this.showRemovePopup = false
      this.itemToRemove = null
    },
    async updateCustomizeStatus(item) {
      if (!item.isCustomise) {
        item.customizationText = ''
      }
      await this.saveCustomization(item)
    },
    async saveCustomization(item) {
      if (this.loggedInUser) {
        try {
          await updateCartItem({
            CartID: item.CartID,
            UserID: this.loggedInUser.UserID,
            CustomisationText: item.customizationText || ''
          })
          item.showSaveBtn = false
          this.emitCartCount()
        } catch (error) {
          console.error('Save failed:', error)
          showMessage('Failed to save customization', 'error')
        }
      } else {
        let localItems = this.getLocalCart()
        const target = localItems.find(i => i.localId === item.localId)
        if (target) {
          target.customizationText = item.customizationText
          this.saveLocalCart(localItems)
        }
        item.showSaveBtn = false
        this.emitCartCount()
      }
    },
    handleInputFocus(item) {
      item.showSaveBtn = true
    },
    handleInputBlur(item) {
      setTimeout(() => { item.showSaveBtn = false }, 200)
    },
    async syncLocalCartToServer() {
      const localItems = this.getLocalCart()
      if (localItems.length === 0 || !this.loggedInUser) return
      let successCount = 0
      for (const item of localItems) {
        try {
          const { addToCart } = await import('@/api/Enquiry')
          const model = {
            ProductID: item.ProductID,
            UserID: this.loggedInUser.UserID,
            CustomisationText: item.customizationText || ''
          }
          const response = await addToCart(model)
          if (response.retCode === 1) successCount++
        } catch (err) {
          console.error('Sync item failed', item, err)
        }
      }
      if (successCount > 0) {
        showMessage(`Synced ${successCount} item(s) to your enquiry list`, 'success')
      }
      this.saveLocalCart([])
      await this.loadCartItems()
    },
    async sendEnquiryForm() {
      if (this.submitting) return
      if (!this.formData.name || !this.formData.email) {
        showMessage('Name and email are required', 'error')
        return
      }
      if (this.enquiryList.length === 0) {
        showMessage('No products in enquiry list', 'error')
        this.closeEnquiryDrawer()
        return
      }
      this.submitting = true
      const products = this.enquiryList.map(item => ({
        ProductID: item.ProductID,
        Quantity: 1,
        CustomisationText: item.isCustomise ? item.customizationText : ''
      }))
      const model = {
        UserID: this.loggedInUser ? this.loggedInUser.UserID : 0,
        Name: this.formData.name,
        Email: this.formData.email,
        Phone: this.formData.phone || '',
        AdditionalNotes: this.formData.notes || '',
        Products: products
      }
      try {
        await submitEnquiry(model)
        this.showEnquirySentPopup = true
        if (this.loggedInUser) {
          await this.loadCartItems()
        } else {
          this.saveLocalCart([])
          this.enquiryList = []
          this.emitCartCount()
        }
      } catch (error) {
        console.error('Submit enquiry failed:', error)
        showMessage('Failed to submit enquiry. Please try again.', 'error')
      } finally {
        this.submitting = false
      }
    },
    closeEnquirySentPopup() {
      this.showEnquirySentPopup = false
      this.closeEnquiryDrawer()
    },
    closeEnquiryDrawer() {
      this.$emit('close')
    },
    openMessagePopup() {
      this.$emit('open-email-popup')
    },
    toggleSearch() {
      this.$emit('toggle-search')
    },
    toggleUserInfo() {
      this.$emit('toggle-user-info')
    },
    autoResize(event) {
      // 可选
    }
  }
}
</script>

<style scoped>
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;
}
.icon-img {
  width: auto;
  height: 17rem;
}

.enquiry-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 3000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease;
  /* 彻底禁用触摸滚动 */
  touch-action: none !important;
}
.enquiry-drawer-overlay.visible {
  opacity: 1;
  visibility: visible;
}

.enquiry-drawer {
  position: fixed;
  z-index: 3001;
  top: 0;
  right: 0;
  width: 70%;
  max-width: 1030rem;
  height: 100%;
  background-color: #fff;
  transform: translateX(100%);
  transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
  display: flex;
  flex-direction: column;
  border-left: 1rem solid #000;
  overscroll-behavior: contain;
}
.enquiry-drawer.open {
  transform: translateX(0);
}

.drawer-header {
  padding: 0rem 60rem 43rem 60rem;
  text-align: center;
  border-bottom: 1rem solid #000;
}
.drawer-header h2 {
  font-size: 24rem;
  font-weight: 600;
  margin: 0;
}
.drawer-content {
  display: flex;
  flex: 1;
  overflow: hidden;
  height: 100%;
}
.drawer-list-column {
  width: 593rem;
  height: 100%;
  border-right: 1rem solid #000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 184rem;
}

.enquiry-list-scroll-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
.enquiry-list-scroll-area::-webkit-scrollbar {
  display: none;
}

.enquiry-item {
  display: flex;
  padding: 0;
  border-bottom: 1rem solid #000;
  position: relative;
  background-color: #fff;
  max-height: 213rem;
  overflow: hidden;
  transition: max-height 0.4s ease;
}
.enquiry-item.expanded {
  max-height: 380rem;
}
.enquiry-item.empty-customization {
  max-height: 213rem;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.4s ease;
  max-height: 150px;
  opacity: 1;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
}
.list-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease !important;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #fff;
}
.list-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.list-move {
  transition: transform 0.5s ease !important;
}

.drawer-form-column {
  width: 50%;
  max-width: 445rem;
  padding: 20rem 37rem 20rem 43rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.drawer-header-icons {
  display: flex;
  justify-content: flex-end;
}
.header-icon-group {
  display: flex;
  align-items: center;
  gap: 18rem;
}
.bag-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.item-image {
  width: 200rem;
  margin-right: 20rem;
  background-color: #f5f5f5;
  border-right: 1rem solid #000;
}
.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.item-details {
  flex: 1;
  flex-direction: column;
  padding: 36rem 0;
  padding-left: 20rem;
  padding-right: 24rem;
}
.item-category {
  font-size: 13rem;
  color: rgba(0, 0, 0, 0.3);
  margin-bottom: 4rem;
  font-weight: 500;
}
.item-name {
  font-size: 20rem;
  font-weight: 500;
  margin-bottom: 20rem;
}
.item-options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 10rem;
  margin-top: 60rem;
}
.drawer-customise-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16rem;
  font-weight: 500;
}
.customization-input-container {
  width: 100%;
  margin-top: 10rem;
}
.customization-input {
  width: 100%;
  border: none;
  font-size: 14rem;
  outline: none;
  color: #000;
  resize: none;
  overflow-y: auto;
  scrollbar-width: thin;
  background: transparent;
  margin-top: 8rem;
  font-family: 'Apercu-Medium', sans-serif;
  border-bottom: 0.5rem solid #000;
  max-height: 40rem;
  height: 23rem;
}
.customization-input::-webkit-scrollbar {
  width: 1rem;
  background: transparent;
}
.customization-input::-webkit-scrollbar-thumb {
  background: #000;
}
.customization-input::placeholder {
  color: #ccc;
}
.save-btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 8rem;
}
.save-btn {
  font-size: 13rem;
  font-weight: 600;
  cursor: pointer;
}
.drawer-customise-checkbox input {
  display: none;
}
.drawer-customise-checkbox .checkmark {
  width: 14rem;
  height: 14rem;
  border: 1rem solid #000;
  border-radius: 2rem;
  margin-right: 10rem;
  position: relative;
  transition: background-color 0.2s;
  box-sizing: border-box;
  display: inline-block;
}
.drawer-customise-checkbox input:checked+.checkmark:after {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  top: 50%;
  width: 10rem;
  height: 10rem;
  background-color: #000;
  transform: translate(-50%, -50%);
  border: none;
}
.item-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 10rem;
}
.item-top-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.remove-btn {
  background: none;
  border: none;
  text-decoration: underline;
  font-size: 13rem;
  cursor: pointer;
  padding: 0;
  font-family: 'Apercu-Medium';
  font-weight: 500;
}
.form-intro {
  padding-top: 197rem;
  margin-bottom: 96rem;
  text-align: center;
}
.form-intro p {
  font-size: 14rem;
  max-width: 300rem;
  margin: 0 auto;
  font-weight: 600;
  padding: 0 34rem;
}
.enquiry-form {
  width: 100%;
  max-width: 350rem;
  margin: 0 auto;
}
.form-group {
  margin-bottom: 8rem;
  height: 30rem;
}
.drawer-input {
  width: 100%;
  border: none;
  border-bottom: 1rem solid #000;
  padding: 10rem 0;
  font-size: 14rem;
  outline: none;
  color: #000;
  font-family: 'Apercu-Medium', sans-serif;
}
.drawer-input::placeholder {
  font-family: 'Apercu-Medium', sans-serif;
}
.drawer-input.textarea {
  resize: none;
  height: 40rem;
}
.send-enquiry-btn {
  background: none;
  border: none;
  font-size: 14rem;
  font-weight: 500;
  cursor: pointer;
  display: block;
  margin-top: 97rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 164rem;
}
.send-enquiry-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.remove-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.remove-popup {
  background-color: #fff;
  padding: 61rem 10rem;
  width: 437rem;
  height: 247rem;
  text-align: center;
  box-shadow: 0 4rem 20rem rgba(0, 0, 0, 0.1);
  border: 2rem solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.remove-popup h3 {
  font-size: 20rem;
  font-weight: 500;
  margin-bottom: 15rem;
  line-height: 1.4;
}
.remove-popup p {
  font-size: 14rem;
  color: rgba(0, 0, 0, 0.3);
  margin-bottom: 30rem;
}
.remove-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  width: 70%;
}
.cancel-btn,
.confirm-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14rem;
  font-weight: 500;
}
.cancel-btn {
  color: #000;
}
.confirm-btn {
  color: rgba(0, 0, 0, 0.3);
}
.popup-scale-enter-active,
.popup-scale-leave-active {
  transition: opacity 0.3s ease;
}
.popup-scale-enter,
.popup-scale-leave-to {
  opacity: 0;
}
.popup-scale-enter-active .remove-popup,
.popup-scale-leave-active .remove-popup {
  transition: transform 0.3s ease;
}
.popup-scale-enter .remove-popup,
.popup-scale-leave-to .remove-popup {
  transform: scale(0);
}
.enquiry-sent-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.enquiry-sent-popup {
  text-align: center;
  width: 437rem;
  height: 247rem;
  background-color: #fff;
  padding: 70rem 0;
  box-shadow: 0 4rem 20rem rgba(0, 0, 0, 0.1);
  border: 1rem solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.enquiry-sent-popup h3 {
  font-size: 20rem;
  font-weight: 500;
  margin-bottom: 15rem;
}
.enquiry-sent-popup .product-count {
  font-size: 14rem;
  font-weight: 600;
  margin-bottom: 71rem;
}
.enquiry-sent-popup .back-text {
  font-size: 14rem;
  color: rgba(0, 0, 0, 0.3);
}
.enquiry-sent-anim-enter-active,
.enquiry-sent-anim-leave-active {
  transition: opacity 0.3s;
}
.enquiry-sent-anim-enter-active .enquiry-sent-popup,
.enquiry-sent-anim-leave-active .enquiry-sent-popup {
  transition: transform 0.3s ease-out;
}
.enquiry-sent-anim-enter,
.enquiry-sent-anim-leave-to {
  opacity: 0;
}
.enquiry-sent-anim-enter .enquiry-sent-popup,
.enquiry-sent-anim-leave-to .enquiry-sent-popup {
  transform: scale(0);
}
.empty-customization-item-details {
  justify-content: space-between;
}

@media (max-width: 768px) {
  .enquiry-drawer {
    width: 90%;
  }
  .drawer-content {
    flex-direction: column;
  }
  .drawer-list-column,
  .drawer-form-column {
    width: 100%;
    border-right: none;
  }
  .drawer-list-column {
    border-bottom: 1rem solid #000;
    border-right: 1rem solid #000;
    height: 50%;
    padding-top: 50rem;
  }
  .drawer-form-column {
    height: 50%;
    overflow-y: auto;
  }
  .enquiry-list-scroll-area {
    max-height: 100%;
  }
}
</style>